import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import NotificationProvider from './components/NotificationProvider';

// Detect Samsung Internet and add compatibility class
const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
if (isSamsungBrowser) {
  document.documentElement.classList.add('samsung-internet');
  // Disable backdrop-filter for Samsung Internet
  document.documentElement.style.setProperty('--supports-backdrop-filter', '0');
  
  // Force light color scheme initially
  document.documentElement.style.colorScheme = 'light';
  document.body.style.colorScheme = 'light';
  
  // Alert user if reading mode might be enabled
  console.log('%c⚠️ Samsung Internet Detected', 'color: #D4AF37; font-size: 16px; font-weight: bold;');
  console.log('%cIf colors look wrong:', 'color: #D4AF37; font-size: 14px;');
  console.log('%c1. Tap the menu icon (☰)', 'color: white; font-size: 12px;');
  console.log('%c2. Check if "Reading mode" is ON - turn it OFF', 'color: white; font-size: 12px;');
  console.log('%c3. Settings → Appearance → disable "Apply dark theme"', 'color: white; font-size: 12px;');
} else {
  document.documentElement.style.setProperty('--supports-backdrop-filter', '1');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // React.StrictMode causes double-render in dev, which can invoke reCAPTCHA logic twice and break the verifier.
  // Temporarily disabling validation to ensure stable reCAPTCHA initialization.
  <Suspense fallback={(
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center">
      <div className="text-xl text-neutral-600">Loading...</div>
    </div>
  )}>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </Suspense>
);